module.exports = "/static/media/lineto-circular-bookItalic.08f55550.eot";